import { useState } from "react"
import {teutonic} from "../../../../data/teutonic"
import ListSelect from "../../ListSelect"
import Btn from "../../Btn"

const Teutonic = (props) => {

    const selectList = teutonic.map(teutonic => ({
        id:teutonic.id,
        name:teutonic.name,
        wood:teutonic.wood,
        clay:teutonic.clay,
        iron:teutonic.iron,
        crop:teutonic.crop,
        all: teutonic.wood + teutonic.clay + teutonic.crop + teutonic.iron
    }) )

    const [selectValue, setSelectValue] = useState("")
    const handleSelectValue = event => {
        setSelectValue(event.target.value)
    }

    function vypis() {
        const selectedTeutonic = selectList[selectValue-1]
        props.addItem(selectedTeutonic)
    }

return (
    <div>
        <ListSelect label="...choose trop..." selectList={selectList} handleSelectValue={handleSelectValue} />
        {selectValue ? (
            <Btn className="btn" type="submit" text="Add to result" onClick={vypis} />
        ) : null}
    </div>
    )
}
export default Teutonic
